import { Editor } from 'grapesjs';
import { buildBackgroundImageStyle } from '@loyalty/editor-components';
import { faColumns } from '@fortawesome/pro-regular-svg-icons/faColumns';
import { ColumnWidgetTraits } from './ColumnWidgetTraits';
import { EditorComponentDefinition } from '../types';
import { Toolbar } from '../../utils';

export const columnComponentDefinition: EditorComponentDefinition = {
  id: 'column',
  icon: faColumns,
  getLabel: ({ t }) => t('editor.component.column'),
  component: ColumnComponent,
  traits: {
    form: ColumnWidgetTraits,
  },
};

export function ColumnComponent(editor: Editor) {
  const CLASSNAME = 'qlfeditor-column';

  editor.DomComponents.addType(columnComponentDefinition.id, {
    isComponent: (el: HTMLElement) => {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        category: 'Basic',
        draggable: false,
        content: '',
        attributes: {
          class: CLASSNAME,
          backgroundImage: undefined,
        },
        traits: [],
      },
      initToolbar: Toolbar,
    },
    view: {
      onRender() {
        const { el, model } = this;
        if (model.attributes.attributes.backgroundImage) {
          el.style = buildBackgroundImageStyle(model.attributes.attributes.backgroundImage);
        } else {
          el.style = '';
        }
      },
    },
  });
}
